<template>
	<el-descriptions :column="2" border>
		<template slot="title">
			<span style="font-size: 0.875em; font-weight: normal">开票信息</span>
		</template>
		<el-descriptions-item>
			<template slot="label">开票类型</template>
			{{ getInvoiceTypeName(invoiceData.invoiceType) }}
		</el-descriptions-item>
		<el-descriptions-item>
			<template slot="label">开票金额</template>
			{{ invoiceData.money }}元
		</el-descriptions-item>
		<el-descriptions-item>
			<template slot="label">
				{{ setTitle }}
			</template>
			{{ invoiceData.identification }}
		</el-descriptions-item>
		<el-descriptions-item>
			<template slot="label">发票抬头</template>
			{{ invoiceData.title }}
		</el-descriptions-item>
		<template v-if="invoiceData.invoiceType == 1 && !isZhuanPiaoHide">
			<el-descriptions-item>
				<template slot="label">注册地址</template>
				{{ invoiceData.address }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">注册电话</template>
				{{ invoiceData.phone }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">开户银行</template>
				{{ invoiceData.bankName }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">开户账号</template>
				{{ invoiceData.bankNo }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">收件人</template>
				{{ invoiceData.mailName }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">手机号</template>
				{{ invoiceData.mailPhone }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">收件人地址</template>
				{{ invoiceData.mailAreaName }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">详细地址</template>
				{{ invoiceData.mailAddress }}
			</el-descriptions-item>
		</template>
	</el-descriptions>
</template>

<script>
import {isFgkZhuanpiao} from '@/util/productUtil'

export default {
	name: 'InvoiceView',
	props: {
		supportSpecial: {
			type: Boolean,
			default: true,
		},
		insureType: Number | String,
	},
	data: function () {
		return {
			invoiceData: {
				invoiceType: '',
				money: 0,
				identification: '',
				title: '',
				address: '',
				phone: '',
				bankName: '',
				bankNo: '',
				mailName: '',
				mailPhone: '',
				mailAreaName: '',
				mailAddress: '',
				taxCertificate: '',
			},
			typeNames: new Map([
				[1, '增值税专票'],
				[2, '增值税普票'],
			]),
		}
	},
	computed: {
		setTitle() {
			return this.invoiceData.title === '个人' ? '身份证号' : '纳税人识别号'
		},
		//insureType 6 和21 ，上海太保去掉其他参数！！！！
		isZhuanPiaoHide() {
			return isFgkZhuanpiao(this.insureType)
		},
	},
	created() {
		this.init()
	},
	methods: {
		init() {},
		setData(data) {
			Object.assign(this.invoiceData, data)
		},
		getInvoiceTypeName(invoiceType) {
			return this.typeNames.get(invoiceType) || ''
		},
	},
}
</script>
